module.exports = __webpack_public_path__ + "static/img/rightshape.0f8458c.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/registerflow-new/rightshape.png
// module id = 0ge3
// module chunks = 4